import { ViewRecipients } from '../../../../common/components/ViewRecipients/ViewRecipients'
import { ViewStakeholders } from '../../../../common/components/ViewStakeholders/ViewStakeholders'
import type { StakeholderUserOption } from '../../../../common/components/ViewStakeholders/stakeholderUserOption'
import type { ViewResellerAuthorizationType } from '../../../../modules/receivedResellerAuthorization/types'
import { ResellerAgreementStatus } from '../../../../types/flyout'
import { useState } from 'react'
import {
  addRecipientsResaleToolTipMessage,
  addStakeholdersResaleToolTipMessage,
} from '../../../../utils/constants'
import type {
  OfferRecipients,
  OfferStakeholders,
} from '../../../../modules/privateOffer/types'
import { useDispatch } from '../../../../store'
import { updateResaleAuthorizationForUser } from '../../../PrivateOfferForm/Recipients/utils'

export const ViewRecipientsStakeholders = ({
  resellerAuthorization,
  externalBaseURL,
  users = [],
}: {
  resellerAuthorization: ViewResellerAuthorizationType
  externalBaseURL?: string
  users?: StakeholderUserOption[]
}) => {
  const dispatch = useDispatch()

  const [openEditRecipient, setOpenEditRecipient] = useState(false)
  const [openEditStakeHolders, setOpenEditStakeholders] = useState(false)

  const hideRecipientStakeHolders =
    resellerAuthorization?.status === ResellerAgreementStatus.COMPLETED

  const isRecipientStakeHoldersDisabled = [
    ResellerAgreementStatus.FAILED,
    ResellerAgreementStatus.EXPIRED,
    ResellerAgreementStatus.RESTRICTED,
    ResellerAgreementStatus.DEACATIVATION_IN_PROGRESS,
  ].includes(resellerAuthorization?.status)

  const handleSubmitRecipient = async (recipients: OfferRecipients[]) => {
    const payload = {
      status: resellerAuthorization?.status,
      awsAgreementId: resellerAuthorization?.awsAgreementId,
      agreementRecipients: recipients,
    }
    await dispatch(
      updateResaleAuthorizationForUser(resellerAuthorization.id, payload)
    )
    setOpenEditRecipient(false)
  }

  const handleSubmitStakeholders = async (
    offerStakeholders: OfferStakeholders[],
    customOfferStakeholders: OfferStakeholders[]
  ) => {
    const payload = {
      status: resellerAuthorization?.status,
      awsAgreementId: resellerAuthorization?.awsAgreementId,
      agreementStakeholders: [
        ...offerStakeholders.map(stakeholder => ({
          firstName: stakeholder.firstName,
          lastName: stakeholder.lastName,
          email: stakeholder.email,
        })),
        ...customOfferStakeholders.map(stakeholder => ({
          firstName: stakeholder.firstName,
          lastName: stakeholder.lastName,
          email: stakeholder.email,
        })),
      ],
    }
    await dispatch(
      updateResaleAuthorizationForUser(resellerAuthorization.id, payload)
    )
    setOpenEditStakeholders(false)
  }

  const labraEmails = users.map(user => user.email)

  return (
    <>
      <ViewRecipients
        offerRecipients={resellerAuthorization?.agreementRecipients}
        handleSubmitRecipient={handleSubmitRecipient}
        setOpenEditRecipient={setOpenEditRecipient}
        openEditRecipient={openEditRecipient}
        isRecipientEditActionDisabled={isRecipientStakeHoldersDisabled}
        addRecipientsResaleToolTipMessage={addRecipientsResaleToolTipMessage}
        hideEditActionRecipient={hideRecipientStakeHolders}
      />
      <ViewStakeholders
        offerStakeholders={(
          resellerAuthorization?.agreementStakeholders || []
        ).filter((item: { email?: string }) =>
          labraEmails.includes(item?.email || '')
        )}
        customOfferStakeholders={(
          resellerAuthorization?.agreementStakeholders || []
        ).filter(
          (item: { email?: string }) => !labraEmails.includes(item?.email || '')
        )}
        handleSubmitStakeholder={handleSubmitStakeholders}
        setOpenEditStakeholders={setOpenEditStakeholders}
        openEditStakeHolders={openEditStakeHolders}
        isStakeholderEditActionDisabled={isRecipientStakeHoldersDisabled}
        addStakeholderToolTipMessage={addStakeholdersResaleToolTipMessage}
        hideEditActionStakeholder={hideRecipientStakeHolders}
        hideStakeholders={!!externalBaseURL}
        users={users}
      />
    </>
  )
}
